const PROXY_ENDPOINT = '/api/gemini-proxy.php';

export async function isGeminiAvailable() {
  try {
    const response = await fetch(PROXY_ENDPOINT, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    console.warn('Image service availability check failed.', error);
    return false;
  }
}

export async function createGeminiImage({ prompt, base64Image = null, mimeType = 'image/png' }) {
  if (!prompt || !prompt.trim()) {
    throw new Error('Prompt is required.');
  }

  const response = await fetch(PROXY_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      prompt,
      base64Image,
      mimeType
    })
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = payload.error || response.statusText || 'Image request failed.';
    throw new Error(message);
  }

  const base64Output = payload.data;
  if (!base64Output) {
    throw new Error('No image output was returned.');
  }
  return base64Output;
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      const base64 = result.split(',')[1];
      resolve({
        base64,
        mimeType: file.type || 'image/png'
      });
    };
    reader.onerror = () => reject(new Error('Failed to read file.'));
    reader.readAsDataURL(file);
  });
}
